import { Component } from '@angular/core';
import { AuthenticationService } from '@assetaccountant/core';

@Component({
  selector: 'app-logout',
  template: '',
  standalone: false,
})
export class LogoutComponent {
  constructor(authService: AuthenticationService) {
    authService.logOut();
  }
}
